import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Study } from '../../../../models/study';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../state';
import { selectSelectedStudy } from '../../../state/study/study.selectors';
import { User } from '../../../../models/user';
import {
  selectIsSingleResearcherVisible,
  selectSelectedStudyResearcher,
  selectStudyResearchers,
} from '../../../state/study-researcher/study-researcher.selectors';
import {
  deleteStudyResearcher,
  setSelectedStudyResearcher,
  setSingleStudyResearcherPageVisibility,
} from '../../../state/study-researcher/study-researcher.actions';
import { openDashboardConfirmationDialog } from '../../../state/dashboard.actions';
import { PrivilegeService } from '../../../services/privilege/privilege.service';
import { PRIVILEGE_ACTIONS, PRIVILEGE_SECTIONS } from '../../../../core/dashboard-constants';

@Component({
  selector: 'dashboard-study-researchers',
  templateUrl: './study-researchers.component.html',
  styleUrls: ['./study-researchers.component.scss'],
})
export class StudyResearchersComponent implements OnInit {
  selectedStudy$: Observable<Study>;
  studyResearchers$: Observable<User[]>;
  selectedStudyResearcher$: Observable<User>;
  singleStudyResearcherVisible$: Observable<boolean>;

  PRIVILEGE_SECTIONS = PRIVILEGE_SECTIONS;
  PRIVILEGE_ACTIONS = PRIVILEGE_ACTIONS;

  isAddResearcher = false;

  constructor(private store: Store<AppState>, public privilegeService: PrivilegeService) {}

  ngOnInit(): void {
    this.selectedStudy$ = this.store.select(selectSelectedStudy);
    this.studyResearchers$ = this.store.select(selectStudyResearchers);
    this.selectedStudyResearcher$ = this.store.select(selectSelectedStudyResearcher);
    this.singleStudyResearcherVisible$ = this.store.select(selectIsSingleResearcherVisible);
  }

  openResearcherDetails(selectedResearcher: User): void {
    this.isAddResearcher = false;
    this.store.dispatch(setSelectedStudyResearcher({ selectedResearcher }));
    this.store.dispatch(setSingleStudyResearcherPageVisibility({ singleResearcherVisible: true }));
  }

  openCreateResearcher(): void {
    this.isAddResearcher = true;
    this.store.dispatch(setSelectedStudyResearcher({ selectedResearcher: null }));
    this.store.dispatch(setSingleStudyResearcherPageVisibility({ singleResearcherVisible: true }));
  }

  deleteStudyResearcher(studyId: number, researcherId: number): void {
    this.store.dispatch(
      openDashboardConfirmationDialog({
        dialogData: {
          title: 'Are you sure you want to delete this researcher?',
          onConfirm: deleteStudyResearcher({ studyId, researcherId }),
        },
      })
    );
  }
}
